import styles from "./calenderBottons.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";
import { IoPrintOutline } from "react-icons/io5";

interface CalenderBottonsProps {
    handleOpenBookingPopup: () => void;
    handleOpenCancelPopup: () => void;
}

export default function CalenderBottons({
    handleOpenBookingPopup,
    handleOpenCancelPopup
}: CalenderBottonsProps) {

    const handlePrint = () => {
        window.print();
    };

    return (
        <>
            <div className={styles.panelButtonContainer}>
                <div className={styles.buttonContainer}>
                    <button
                        className={`${commonStyles.commonButton} ${styles.bookingButton}`}
                        onClick={handleOpenBookingPopup}
                    >
                        <p>Neue Buchung</p>
                        <FaCirclePlus className={commonStyles.commonButtonIcon} />
                    </button>
                    <button className={`${commonStyles.commonButton} ${styles.cancelButton}`}
                                            onClick={handleOpenCancelPopup}
>
                        <span>Stornierung</span>
                        <FaCircleMinus className={commonStyles.commonButtonIcon} />
                    </button>
                </div>
                <button className={styles.printButton} onClick={handlePrint}>
                    <span>Drucken</span>
                    <IoPrintOutline />
                </button>
            </div>
        </>
    );
}
